export default {
  maxNumberOfPropertiesPerPage: 30,
  minNumberOfPropertiesToAllowFilters: 20,
  socialCues: { limitAvatars: 3 },
};
